import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ExcelColumn } from 'app/modules/common/entities/leave-import/template.model';
import { ExcelColumnsService } from '../services/excel-columns.service';


// options for each row
const options = [
    "% Jornada",
    "Acc. – Causa",
    "Acc. – Cód. Riesgos As.",
    "Acc. – Descripción",
    "Acc. – Grado Grav.",
    "Acc. – Localización (Atrib.)",
    "Acc. – Lugar",
    "Acc. – Medidas",
    "Apellido 1",
    "Apellido 2",
    "Apellidos y Nombre",
    "Atributo 1",
    "Atributo 2",
    "Atributo 3",
    "Atributo 4",
    "Atributo 5",
    "Atributo 6",
    "Atributo 7",
    "Atributo 8",
    "Atributo 9",
    "Atributo 10",
    "Atributo 11",
    "Atributo 12",
    "Calle",
    "Comentario",
    "CP",
    "CP Poblacion",
    "Edad",
    "Empresa",
    "Empresa 2",
    "Empresa3",
    "Escalera",
    "Eulen Jornada 1",
    "F. Alta",
    "F. Alta (DD.MM.AAAA)",
    "F. Antigüedad",
    "F. Baja",
    "F. Baja (DD.MM.AAAA)",
    "F. Fin Contrato",
    "F. Nacimiento",
    "Linea venta",
    "Desc Linea venta",
    "NIF",
    "Nombre",
    "Numero (Calle)",
    "Piso",
    "Poblacion",
    "Provincia",
    "Puerta",
    "Puesto",
    "Recaída",
    "Ref. Trabajador",
    "Ref. Baja",
    "S.S.",
    "Sexo (H/D)",
    "Sexo (H/M)",
    "Telefono",
    "Telefono 2",
    "Telefono 3",
    "Telefonos",
    "Tipo Baja",
    "Via",
];


// type of a row in excel columns table
export type ExcelColumnTableRow = ExcelColumn & {
    label: string;
};


@Component({
    selector: 'app-leave-import-excel',
    templateUrl: './leave-import-excel.component.html',
    styleUrls: ['./leave-import-excel.component.scss'],
    standalone: false
})

export class LeaveImportExcelComponent {

    dropDownOptions = options;
    displayedColumns: string[] = ['label', 'campo'];


    constructor(
        public excelColumnsService: ExcelColumnsService,
    ) { }

}
